import { Feature, GeoJsonProperties, LineString } from "geojson";
import { RootStore } from "../../../../shared/stores/RootStore";
import { toast, toaster } from "../../../../shared/views/CustomToaster";
import { createWayFromLineFeature } from "../shared/createWayFromLineFeature";
import { MapMode } from "../../../../survey/stores/MapStore";

export async function importSelectedCategories(
  featuresInSelection: Feature<LineString, GeoJsonProperties>[],
  rootStore: RootStore,
  map: mapboxgl.Map,
  rightHandTraffic: boolean,
) {
  const { mapQueryStore, hlaStore, surveyStore, mapStore } = rootStore;

  const totalFeatures = featuresInSelection.length;
  var featureCounter = 0;
  var wayCounter = 0;

  const toastId = toast(
    "loading",
    `Querying your area selection. Please wait...`,
  );

  const survey = surveyStore.getSelected()!;

  const enabledCategories = mapQueryStore.compositeCategories
    .filter((cc) => cc.enabled)
    .map((cc) => cc.name);

  for (const feature of featuresInSelection) {
    const featureId = feature.id as number;

    const way = await createWayFromLineFeature(
      featureId,
      feature.geometry.coordinates,
      feature.properties,
      enabledCategories,
      map,
      rightHandTraffic,
    );

    if (way) {
      console.log("Resulting way", way);

      way.surveyId = survey.id;
      // TODO comment
      // importHlaUtils.addRequestToMap(way, rootStore);
      // TODO uncomment
      await hlaStore.create(way);
      wayCounter++;
    }

    featureCounter++;

    toaster.update(toastId, {
      title: `Processing features (${featureCounter} of ${totalFeatures})`,
    });
  }

  toaster.update(toastId, {
    type: "success",
    title: `Done! ${wayCounter} ways imported`,
  });

  hlaStore.updateMapSource();
  mapQueryStore.deactivate();

  mapStore.setMode(MapMode.SurveyPage);
}
